import { DATA_CONSENT_POLICY_VERSION } from './policy';

const STORAGE_KEY = 'ielect-data-consent';

export interface ConsentStorage {
	policyVersion: string;
	consentReference: string | null;
	consents: {
		dataProcessing: boolean;
		biometricVerification: boolean;
		futureContact: boolean;
	};
	acceptedAt: number;
}

export const saveConsent = (record: Omit<ConsentStorage, 'acceptedAt'>) => {
	try {
		const storage: ConsentStorage = { ...record, acceptedAt: Date.now() };
		sessionStorage.setItem(STORAGE_KEY, JSON.stringify(storage));
	} catch {
		// sessionStorage may be unavailable (private mode / quota) — non-fatal.
	}
};

// Returns a previously-recorded consent only if it matches the current policy
// version. A version bump re-prompts the user, as required for fresh consent.
export const checkExistingConsent = (): ConsentStorage | null => {
	try {
		const raw = sessionStorage.getItem(STORAGE_KEY);
		if (!raw) return null;
		const parsed = JSON.parse(raw) as ConsentStorage;
		if (parsed.policyVersion !== DATA_CONSENT_POLICY_VERSION) return null;
		if (!parsed.consents?.dataProcessing || !parsed.consents?.biometricVerification) return null;
		return parsed;
	} catch {
		return null;
	}
};
